export default __webpack_public_path__ + "static/media/publish.17d5f121.svg";